import { useFeatureFlagWithConditions } from '../feature-flags';
import { useAccountData } from './useAccountData';
import { useHasApiIntegration } from './useHasApiIntegration';

/**
 * Whether the bulk import reference-key / JSON settings controls (used by the bulk import API)
 * should be visible.
 *
 * Enabled when the `jsonProductsImport` feature flag targets the current user, OR when the
 * seller has at least one active API sales channel (ecommerceName === 'API').
 */
export const useJsonProductsImportEnabled = (): boolean => {
    const { userInfo } = useAccountData();
    const hasApiIntegration = useHasApiIntegration();

    const isFlagEnabled = useFeatureFlagWithConditions('jsonProductsImport', {
        userId: userInfo?.userID?.toString()
    });

    return isFlagEnabled || hasApiIntegration;
};
